import { useEffect, useRef, useState } from "react";
import "./confirm-dialog-style.css";

const AlertDialog = ({
  open,
  onClose,
  onSuccess,
  title = "",
  message = "",
  confirmTxt = "",
  image = "/images/ic-default-userphoto.png",
}) => {
  // 鎖背景滾動 + ESC 關閉
  useEffect(() => {
    if (!open) return;

    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    const prevOverflow = document.body.style.overflow;
    const prevPaddingRight = document.body.style.paddingRight;

    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPaddingRight;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
  }, [open, onClose, onSuccess]);

  if (!open) return null;

  return (
    <div className="alert-backdrop" onMouseDown={onClose}>
      <div className="alert-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="close-btn" onClick={onClose}>
          <img src={`/images/ic-white-close.png`} alt="close" />
        </div>

        <div className="alert-content">
          <img src={image} alt="close" />
          <span className="title">{title}</span>
          <div className="message">
            <span dangerouslySetInnerHTML={{ __html: message }} />
          </div>
          <button
            className="confirm"
            onClick={() => {
              //只觸發 onSuccess；不要自動再呼叫 onClose，否則：
              //  1. consumer 寫了「onClose=回首頁」之類的副作用 → 覆蓋 onSuccess 的 navigate
              //  2. 雙重 navigate 順序不可控
              //  consumer 要在 onSuccess 自己關 dialog（setOpen(false)）
              onSuccess?.();
            }}
          >
            {confirmTxt}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;
